import {
  resetAllTasks,
  RuntimeModeType,
  setONNXTask,
  TASK_STATUS,
  useDeploy,
} from '../TestDeployView/useDeploy';
import {Application, SinglePageApplication} from '../../types/project/Application';
import {StreamingDevice} from '../../types/deployment/StreamingDeviceResponse';
import {InputSource} from '../../types/deployment/InferenceInputSource';
import {Deployment} from '../../types/deployment/DeploymentResponse';
import {useDeployTask} from '../TestDeployView/DeployConfigPanel/useDeployTask';
import {VideoStreamSubject} from '../TestDeployView/HlsVideoStream';
import {useHlsStreamingTask} from '../TestDeployView/DeployConfigPanel/useHlsStreamingTask';

export type InferenceAppConfig = {
  application: Application;
  spa: SinglePageApplication;
  inferenceSource?: Exclude<InputSource, 'IMAGES'>;
  streamSubject: VideoStreamSubject;
  streamingDevices?: StreamingDevice[];
  ipCamera?: string | null;
  runtimeMode?: RuntimeModeType | null;
  onStartDeploy?: (deployment: Deployment) => void;
};

export const useInferenceAppTask = (projectId: string) => {
  const [{onnxTask}, dispatch] = useDeploy();
  const {terminateDeploy} = useDeployTask(projectId);
  const [runTestInference] = useHlsStreamingTask(projectId);

  const handleInferenceStop = (callback: () => void, optId?: string) => {
    if (onnxTask.status !== TASK_STATUS.IDLE) {
      dispatch(setONNXTask({status: TASK_STATUS.IDLE}));
    }
    terminateDeploy(optId);
    callback();
  };

  const handleInferenceStart = (config: InferenceAppConfig) => {
    dispatch(resetAllTasks());
    const isONNXRuntimeWeb = config.application.runtimeType === 'ONNX_RUNTIME_WEB';
    if (isONNXRuntimeWeb) {
      dispatch(
        setONNXTask({
          status: TASK_STATUS.IN_PROGRESS,
          id: Date.now().toString(),
          params: {
            deploymentId: config.spa.applicationId,
            files: [],
            inferenceSource: config.inferenceSource ? config.inferenceSource : '',
            runtimeMode: config.runtimeMode ? config.runtimeMode : 'wasm',
            videoFile: '',
            ipCamera: config.ipCamera ? config.ipCamera : '',
          },
        })
      );
    } else {
      runTestInference({
        projectId,
        applicationId: config.spa.applicationId,
        spaId: config.spa.id,
        name: config.application.name + ' - ' + Date.now(),
        description: '',
        inferenceSource: config.inferenceSource,
        streamingDevices: config.streamingDevices ? config.streamingDevices : [],
        schedulerId: config.spa.target.schedulerId,
        videoFile: '',
        streamSubject: config.streamSubject,
        ipCamera: config.ipCamera ? config.ipCamera : '',
        onStartDeploy: config.onStartDeploy,
      });
    }
  };

  return {handleInferenceStart, handleInferenceStop};
};
